var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForeningshus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.894,8.261a.5.5,0,1,0-.5-.5A.5.5,0,0,0,4.894,8.261Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.391,8.443H4.422a.546.546,0,0,0-.557.535l.092,1.612a.537.537,0,0,0,.382.507.092.092,0,0,1,.065.08l.139,1.193a.358.358,0,0,0,.363.325h0a.357.357,0,0,0,.363-.325l.139-1.193a.093.093,0,0,1,.066-.08.537.537,0,0,0,.381-.507l.093-1.612A.547.547,0,0,0,5.391,8.443Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.648,8.261a.5.5,0,1,0-.5-.5A.5.5,0,0,0,7.648,8.261Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.146,8.443h-.97a.546.546,0,0,0-.557.535l.093,1.612a.537.537,0,0,0,.381.507.093.093,0,0,1,.066.08L7.3,12.37a.357.357,0,0,0,.363.325h0a.358.358,0,0,0,.363-.325l.139-1.193a.092.092,0,0,1,.065-.08.537.537,0,0,0,.382-.507L8.7,8.978A.546.546,0,0,0,8.146,8.443Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,8.261a.5.5,0,1,0-.5-.5A.5.5,0,0,0,10.4,8.261Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9,8.443H9.931a.546.546,0,0,0-.557.535l.093,1.612a.536.536,0,0,0,.381.507.094.094,0,0,1,.066.08l.138,1.193a.358.358,0,0,0,.363.325h0a.357.357,0,0,0,.363-.325l.139-1.193a.093.093,0,0,1,.066-.08.537.537,0,0,0,.381-.507l.093-1.612A.546.546,0,0,0,10.9,8.443Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.226,5.2,8.033,2.083a.46.46,0,0,0-.475,0L2.364,5.2a.462.462,0,0,0,.475.793L7.8,3.018l4.956,2.97a.462.462,0,0,0,.475-.793Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeningshus);
export default __webpack_public_path__ + "static/media/FORENINGSHUS.89578ba00b037a6ae062b20d9653f60a.svg";
export { ForwardRef as ReactComponent };